import * as React from 'react';
import classnames from 'classnames';

import './help-dropdown.scss';

type Props = {
  isVisible: boolean,
  children?: React.ReactNode | null,
  onClose: () => void
};

const HelpDropDown = (
  {
    isVisible,
    children,
    onClose
  }: Props
): JSX.Element => {
  const menuClassNames = classnames('help-dropdown', {
    'help-dropdown--visible': isVisible
  });

  return (
    <React.Fragment>
      {isVisible && (
        <div className="help-dropdown__overlay" onClick={onClose} />
      )}
      <div className={menuClassNames}>
        {children}
      </div>
    </React.Fragment>
  );
};

export default HelpDropDown;
